module.exports = __webpack_public_path__ + "img/prize_b3.f6ed8d60.png";